import { createObservableValue } from '@prodcard/core'

export const showCredits = createObservableValue<boolean>(false)
